import { Card, CardContent } from '@/components/ui/card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { useLanguage } from '@/i18n/LanguageContext';

const ChartTooltip = ({ active, payload, label, currency }) => {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className="bg-card border border-border rounded-sm px-3 py-2 shadow-lg">
      <p className="text-xs text-muted-foreground mb-1">{label}</p>
      {payload.map((entry) => (
        <p key={entry.dataKey || entry.name} className="text-sm font-bold" style={{ color: entry.color }}>
          {entry.name}: {currency && 'CHF '}
          {typeof entry.value === 'number' ? entry.value.toFixed(currency ? 2 : 0) : entry.value}
        </p>
      ))}
    </div>
  );
};

export const RevenueOverTimeChart = ({ monthlyData }) => {
  const { t } = useLanguage();
  return (
    <Card className="bg-card border-border lg:col-span-2">
      <CardContent className="p-6">
        <h3 className="text-lg font-bold mb-4">{t('analytics.revenueOverTime')}</h3>
        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={monthlyData}>
              <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
              <XAxis dataKey="label" tick={{ fontSize: 11, fill: 'hsl(var(--muted-foreground))' }} />
              <YAxis tick={{ fontSize: 11, fill: 'hsl(var(--muted-foreground))' }} />
              <Tooltip content={<ChartTooltip currency={true} />} />
              <Bar dataKey="revenue" name={t('analytics.revenue')} fill="hsl(var(--primary))" radius={[3, 3, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};
